import { EnglishArabicDTO } from "bbsf-controls"
export class LookUpItem
{
      ID:number
      UpdatedID:number
      Name :EnglishArabicDTO=new EnglishArabicDTO();
      Manageable :boolean
      DisplayOrder?:number
      IDEncrypted :string
      Value :string
      LookupID?:number
      LookupName :EnglishArabicDTO=new EnglishArabicDTO();
      SysName :string
      IsParentLookupManageable:boolean
      }
     